<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <Settings
        v-bind:region="'left'"
        v-bind:title="resource('TemplateBlockSettings_Settings_Title')"
        v-bind:tooltip="tooltip"
        class="block-settings"
    >
        <template v-slot:body
        >    
            <settings-slider
                v-bind:label="resource('TemplateBlockSettings_Settings_Width_Label')"
                v-bind:value="width"
                v-bind:min="250"
                v-bind:max="900"
                v-bind:value-suffix="'px'"
                @input="$emit('change-width', $event)"
            />

            <settings-color-picker
                v-bind:label="resource('TemplateBlockSettings_Settings_Color_Label')"
                v-bind:value="color"
                @input="$emit('change-color', $event)"
            />

            <settings-color-picker
                v-bind:label="resource('TemplateBlockSettings_Settings_Border_Color_Label')"
                v-bind:value="borderColor"
                @input="changeBorder($event)"
            />

            <settings-slider
                v-bind:label="resource('TemplateBlockSettings_Settings_Border_Radius_Label')"
                v-bind:value="radius"
                v-bind:value-suffix="'px'"
                @input="$emit('change-radius', $event)"
            />
        </template>
    </Settings>
</template>

<script
>    import {blockSettingsTooltip} from "../../tooltips";

    import resourceMixin from "../../../../Util/Mixins/resources";

    import SettingsSlider from "./SettingsSlider.vue";
    import SettingsColorPicker from "./SettingsColorPicker.vue";
    import Settings from './Settings.vue';

    export default {
        name: "block-settings",
        mixins: [resourceMixin],
        components: {
            SettingsSlider,
            SettingsColorPicker,
            Settings
        },
        methods: {
            changeBorder(value) {

                if(value != '')
                    this.$emit('set-border', true);
                else
                    this.$emit('set-border', false);

                this.$emit('change-border-color', value);
            }
        },
        data: () => ({ 
            tooltip: blockSettingsTooltip
        }),
        props: {
            width: {
                type: Number
            },
            radius: {
                type: Number,
                required: true
            },
            border: {
                type: Boolean,
                default: true
            },
            borderColor: {
                type: String,
                required: true
            },
            color: {
                type: String,
                required: true
            },
            parentColor: {
                type: String
            }
        }
    };
</script>
